import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared';
import { Core2Config } from '../shared';
import {CatalogLoginSubjectLinkFileHelperContainerModel} from '../../../../../models/aggregates/upload-user-to-catalog/user-to-catalog-link-import-file-helper-container.model';

@Injectable({
  providedIn: 'root'
})
export class CatalogLoginSubjectLinkFileHelperService extends BaseApiTemplateService<CatalogLoginSubjectLinkFileHelperContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'catalog-login-subject-link-import-file-helpers/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'catalog-login-subject-link-import-file-helpers/backoffice-ep';
    this.httpClient = http;
  }
}